module.exports = __webpack_public_path__ + "images/93e8af5992b1b61fb1a49c8112d6c231-illu_keypad.svg";